<template>
  <div
    class="search--section"
    :class="{ 'xmas-decoration': canUseXmasDecoration }"
  >
    <div class="title">
      <span>
        {{ $i18nPresenter.t("Ready-made Presentation Templates") }}
      </span>
    </div>
    <div class="search">
      <TemplateSearchV2 />
    </div>
    <div class="categories"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TemplateSearchV2 from '@/components-v2/template/TemplateSearch-v2.vue'

export default {
  components: {
    TemplateSearchV2,
  },
  data() {
    return {
      showModalPublishPresentations: false,
    }
  },
  computed: {
    ...mapGetters('featureToggles', ['canUseXmasDecoration']),
  },
}
</script>

<style scoped lang='scss'>
.search--section {
  @apply pb-4 -mt-1;
  background-image: url('../../../../assets/images/background/search-section-bg.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;

  &.xmas-decoration {
    background-image: url('../../../../assets/images/background/CRE342-banner--template-library.png');
  }

  @apply flex flex-col;

  @media (min-width: 1024px) {
    @apply relative flex flex-col items-center justify-center;
    padding-top: 44px;
    padding-bottom: 20px;
  }
}

.title {
  @apply font-bold text-base-0 text-2xl;
  text-align: center;

  @media (max-width: 1024px) {
    @apply mx-auto mt-8;
    max-width: 18rem;
  }
}

.categories {
  @apply mt-5;

  @media (max-width: 1024px) {
    @apply pl-6 pr-0;
  }

  @media (min-width: 1024px) {
    width: 75%;
  }
}

.search {
  @apply mt-5 mx-auto;

  @media (min-width: 640px) {
    @apply w-1/2;
  }

  @media (max-width: 640px) {
    width: 22rem;
    max-width: 90%;
  }
}
</style>
